import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-experience-summary',
  templateUrl: './experience-summary.component.html',
  styleUrls: ['./experience-summary.component.css']
})
export class ExperienceSummaryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
